import React, { ReactNode } from 'react';
import {
  FormControl as ChakraFormControl,
  FormControlProps,
} from '@chakra-ui/react';

type PropsType = {
  children: ReactNode;
} & FormControlProps;

const FormControl = ({ children, ...props }: PropsType): JSX.Element => (
  <ChakraFormControl
    mb={5}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </ChakraFormControl>
);

export default FormControl;
